import { FormGroup } from "@mui/material";
import { DropdownFilter } from "../../../../../../components/dataGridFilter/filter-components/DropdownFilter";
import { OperatorBasedDropdownFilter } from "../../../../../../components/dataGridFilter/filter-components/OperatorBasedDropdownFilter";
import { OptionBasedDropdownFilter } from "../../../../../../components/dataGridFilter/filter-components/OptionBasedDropdownFilter";
import { SwitchFilter } from "../../../../../../components/dataGridFilter/filter-components/SwitchFilter";

export const FilterGroup1 = ({
  isPendingApprove,
}: {
  isPendingApprove: boolean;
}) => {
  const baseKey =
    "pages.inventoryManagement.inventory.list.filters.filterGroup1";

  const lowestKey = isPendingApprove ? "canBeLowest" : "isLowest";

  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      {!isPendingApprove && (
        <SwitchFilter
          name="onlySoldByMe"
          labelKey={`${baseKey}.onlySellerMe`}
        />
      )}
      <SwitchFilter
        name="marketplaceProduct.marketplaceSummary.buyBoxPriceAmount"
        operator={"null"}
        labelKey={`${baseKey}.noBuyboxWinner`}
      />
      {!isPendingApprove && (
        <DropdownFilter
          name="isMyOfferBuyBuxWinner"
          labelKey={`${baseKey}.hasBuybox.title`}
          operator="eq"
          hideLabelInChip
          options={[
            { value: "true", label: `${baseKey}.hasBuybox.options.true` },
            { value: "false", label: `${baseKey}.hasBuybox.options.false` },
          ]}
        />
      )}
      <DropdownFilter
        name="isMyOfferLowest"
        labelKey={`${baseKey}.${lowestKey}.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.${lowestKey}.options.true` },
          { value: "false", label: `${baseKey}.${lowestKey}.options.false` },
        ]}
      />
      {!isPendingApprove && (
        <OptionBasedDropdownFilter
          labelKey={`${baseKey}.minMaxPrice.title`}
          options={[
            {
              name: "isMyOfferReachedMinimumMargin",
              label: `${baseKey}.minMaxPrice.options.true`,
            },
            {
              name: "isMyOfferReachedMaximumMargin",
              label: `${baseKey}.minMaxPrice.options.false`,
            },
          ]}
        />
      )}
      <DropdownFilter
        name="marketplaceProduct.marketplaceSummary.hasPrimeSeller"
        labelKey={`${baseKey}.localPrime.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.localPrime.options.true` },
          { value: "false", label: `${baseKey}.localPrime.options.false` },
        ]}
      />
      <OperatorBasedDropdownFilter
        name="marketplaceProduct.marketplaceSummary.mainCategorySalesRank"
        labelKey={`${baseKey}.mainSalesRank.title`}
        options={[
          {
            operator: "notNull",
            label: `${baseKey}.mainSalesRank.options.true`,
          },
          {
            operator: "null",
            label: `${baseKey}.mainSalesRank.options.false`,
          },
        ]}
        value={""}
      />
      <OperatorBasedDropdownFilter
        name="marketplaceProduct.marketplaceSummary.subCategorySalesRank"
        labelKey={`${baseKey}.leafSalesRank.title`}
        options={[
          {
            operator: "notNull",
            label: `${baseKey}.leafSalesRank.options.true`,
          },
          {
            operator: "null",
            label: `${baseKey}.leafSalesRank.options.false`,
          },
        ]}
        value={""}
      />
      <DropdownFilter
        name="marketplaceProduct.marketplaceSummary.hasShipFromChina"
        labelKey={`${baseKey}.chineseSeller.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.chineseSeller.options.true` },
          { value: "false", label: `${baseKey}.chineseSeller.options.false` },
        ]}
      />
      <DropdownFilter
        name="marketplaceProduct.marketplaceSummary.hasSBASeller"
        labelKey={`${baseKey}.amazonSeller.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.amazonSeller.options.true` },
          { value: "false", label: `${baseKey}.amazonSeller.options.false` },
        ]}
      />
    </FormGroup>
  );
};
